module.exports = __webpack_public_path__ + "_assets/img/download_1.144cc370.png";